<template>
    <div v-if="beta_features.includes('GATEWAY_VERIFICATION')">
        <Header title="Server Gateway" />
        <div class="middle-wrapper">
        <div v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
        <div class="empty-section-container capcha-container" v-if="loaded">
            <div class="section-author-container">
              <img src="" alt="guild icon">
              <h3></h3>
            </div>
            <div class="empty-section-title">Robot Verification</div>
            <div class="empty-section-description">Check the box below to verify.</div>
            <div class="empty-section-button solid-button color-white cf-turnstile" data-sitekey="0x4AAAAAAAEMFLrqdx4sTCn4"></div>
            <div class="empty-section-description text-red" v-if="error">{{ error }}</div>
            <div class="empty-section-description">Powered by <a href="https://modcord.com/" class="link" target="_blank">ModCord</a>.</div>
            <a class="empty-section-button solid-button color-white thin-button background-blue" @click="verifyUser()"><i class="fas fa-key"></i> Enter Server</a>
        </div>
      </div>
    </div>
  </template>
  
<script>
import { mapGetters } from "vuex";
import Header from "@/components/Header.vue";
  
  export default {
    name: "GatewayVerification",
    components: {
      Header
    },
    computed: mapGetters(["beta_features"]),
    data () {
      return {
        error: "",
        guild: {},
        user: {},
        loaded: false,
      }
    },
    methods: {
      loadTurnstile () {
        const script = document.createElement("script");
        script.setAttribute("src", "https://challenges.cloudflare.com/turnstile/v0/api.js");
        document.head.appendChild(script);
      },
      verifyUser () {
        const [capchaInput] = document.getElementsByTagName("input");
        if (!capchaInput || !capchaInput.value) this.error = "Please complete the capcha.";
        //const verificationValue = capchaInput.value;
      }
    },
    mounted () {
      this.loaded = true;
      this.loadTurnstile();
    }
  }
</script>
  
<style>
.middle-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-section-icon img {
  height: 4em;
  width: 4em;
}

.capcha-container {
  background-color: var(--light-grey-blue);
  padding: 3em;
  align-items: center;
  border-radius: 0.3em;
  box-shadow: 5px 5px 25px 5px rgba(0,0,0,.5);
}

.empty-section-button {
  margin-top: 0!important;
}
</style>